import Vue from 'vue';

const getInput = (el) => {
  if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
    const els = el.getElementsByTagName('input');
    if (els.length !== 1) {
      throw new Error(`v-mask requires 1 input, found ${els.length}`);
    } else {
      el = els[0];
    }
  }
  return el;
};

const maskit = (val, mask, tokens, masked = true) => {
  const value = val || '';
  mask = mask || '';
  let iMask = 0;
  let iValue = 0;
  let output = '';
  while (iMask < mask.length && iValue < value.length) {
    var cMask = mask[iMask];
    const masker = tokens[cMask];
    const cValue = value[iValue];
    if (masker && !masker.escape) {
      if (masker.pattern.test(cValue)) {
        output += masker.transform ? masker.transform(cValue) : cValue;
        iMask++;
      }
      iValue++;
    } else {
      if (masker && masker.escape) {
        iMask++; // take the next mask char and treat it as char
        cMask = mask[iMask];
      }
      if (masked) output += cMask;
      if (cValue === cMask) iValue++; // user typed the same char
      iMask++;
    }
  }

  // fix mask that ends with a char: (#)
  let restOutput = '';
  while (iMask < mask.length && masked) {
    var cMask = mask[iMask];
    if (tokens[cMask]) {
      restOutput = '';
      break;
    }
    restOutput += cMask;
    iMask++;
  }


  return output + restOutput;
};

const unmasked = (val = '') => val && (val.match(/\d+/g) || []).join('');

const tokens = {
  '#': { pattern: /\d/ },
  X: { pattern: /[0-9a-zA-Z]/ },
  S: { pattern: /[a-zA-Z]/ },
  A: {
    pattern: /[a-zA-Z]/,
    transform: v => v.toLocaleUpperCase(),
  },
  a: {
    pattern: /[a-zA-Z]/,
    transform: v => v.toLocaleLowerCase(),
  },
  '!': { escape: true },
};

const fn = (el, binding, vnode) => {
  let pattern = binding.value;

  if (Array.isArray(pattern) || typeof pattern === 'string') {
    pattern = {
      mask: pattern,
      tokens,
    };
  }


  el = getInput(el);


  el.oninput = function (e) {
    if (!e.isTrusted) return;

    el.value = maskit(el.value || vnode.data.model.value, pattern.mask, pattern.tokens, true);
    el.dispatchEvent(new Event('input'));
  };

  const newDisplay = maskit(el.value || vnode.data.model.value, pattern.mask, pattern.tokens, true);
  if (newDisplay !== el.value) {
    el.value = newDisplay;
    el.dispatchEvent(new Event('input'));
  }
};

Vue.directive('mask', {
  bind: fn,
  componentUpdated: fn,
});


Vue.prototype.$mask = {
  unmasked,
};
